import React from 'react';
import './VerticalDecoration.css';

const VerticalDecoration = ({ text }) => {
  return (
    <>
      <div className="vertical-line"></div>
      <div className="vertical-text">
        <span className="vertical-text-content" key={text}>
          {text}
        </span>
      </div>
    </>
  );
};

export default VerticalDecoration;